import React from "react";
import "./NotFound.css";

export default function NotFound() {
  return (
    <div className="NotFound">
      <h3>Gestión de Permisos de Importación: Plaguicidas y Fertilizantes</h3>
	  <img src="HONDURAS.png" alt="Gobierno de Honduras"/>
    </div>
  );
}
